import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features16.css'

const Features16 = (props) => {
  return (
    <div className="features16-layout300 thq-section-padding">
      <div className="features16-max-width thq-section-max-width">
        <div className="features16-section-title">
          <div className="features16-content1">
            <h2 className="features16-text10 thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="features16-text14">Our Solution</span>
                </Fragment>
              )}
            </h2>
            <span className="features16-text11 thq-body-large">
              {props.content1 ?? (
                <Fragment>
                  <span className="features16-text15">
                    An end-to-end autonomous AI Sign Language Agent
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        </div>
        <div className="features16-content2">
          <div className="features16-row thq-flex-row">
            <div className="features16-feature1">
              <img
                alt={props.feature1ImageAlt}
                src={props.feature1ImageSrc}
                className="features16-feature1-image thq-img-ratio-4-3"
              />
              <div className="features16-content3">
                <h3 className="features16-feature1-title thq-heading-3">
                  {props.feature1Title ?? (
                    <Fragment>
                      <span className="features16-text18">Prop Content</span>
                    </Fragment>
                  )}
                </h3>
                <span className="thq-body-small">
                  {props.feature1Description ?? (
                    <Fragment>
                      <span className="features16-text13">Prop Content</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="features16-feature2">
              <img
                alt={props.feature2ImageAlt}
                src={props.feature2ImageSrc}
                className="features16-feature2-image thq-img-ratio-4-3"
              />
              <div className="features16-content4">
                <h3 className="thq-heading-3">
                  {props.feature2Title ?? (
                    <Fragment>
                      <span className="features16-text16">Prop Content</span>
                    </Fragment>
                  )}
                </h3>
                <span className="thq-body-small">
                  {props.feature2Description ?? (
                    <Fragment>
                      <span className="features16-text17">Prop Content</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="features16-feature3">
              <img
                alt={props.feature3ImageAlt}
                src={props.feature3ImageSrc}
                className="features16-feature3-image thq-img-ratio-4-3"
              />
              <div className="features16-content5">
                <h3 className="thq-heading-3">
                  {props.feature3Title ?? (
                    <Fragment>
                      <span className="features16-text12">Prop Content</span>
                    </Fragment>
                  )}
                </h3>
                <span className="thq-body-small">
                  {props.feature3Description ?? (
                    <Fragment>
                      <span className="features16-text19">Prop Content</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features16.defaultProps = {
  feature3Title: undefined,
  feature1Description: undefined,
  feature2ImageAlt: 'VR/AR Integration',
  feature1ImageSrc:
    'https://images.unsplash.com/photo-1591621839477-83880c7ec521?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNXw&ixlib=rb-4.0.3&q=80&w=1400',
  heading1: undefined,
  content1: undefined,
  feature3ImageAlt: 'Deaf Community Engagement',
  feature3ImageSrc:
    'https://images.unsplash.com/photo-1730367796069-f8272f5249bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNnw&ixlib=rb-4.0.3&q=80&w=1400',
  feature2Title: undefined,
  feature2Description: undefined,
  feature1Title: undefined,
  feature1ImageAlt: 'Real-time Sign Language Translation',
  feature3Description: undefined,
  feature2ImageSrc:
    'https://images.unsplash.com/photo-1677447807174-60a70de4a63e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNnw&ixlib=rb-4.0.3&q=80&w=1400',
}

Features16.propTypes = {
  feature3Title: PropTypes.element,
  feature1Description: PropTypes.element,
  feature2ImageAlt: PropTypes.string,
  feature1ImageSrc: PropTypes.string,
  heading1: PropTypes.element,
  content1: PropTypes.element,
  feature3ImageAlt: PropTypes.string,
  feature3ImageSrc: PropTypes.string,
  feature2Title: PropTypes.element,
  feature2Description: PropTypes.element,
  feature1Title: PropTypes.element,
  feature1ImageAlt: PropTypes.string,
  feature3Description: PropTypes.element,
  feature2ImageSrc: PropTypes.string,
}

export default Features16
